import styled from "styled-components";

export const OngoingJobsWrapper = styled.div`
  min-height: 100vh;

  .search-section {
    padding: 0 0 16px 0;
    width: 100%;

    .search-input {
      width: 100%;

      .ant-input-affix-wrapper {
        border-radius: 8px;
        border: 1px solid #d9d9d9;
        padding: 8px 16px;
        background: white;

        &:hover { border-color: #00d9a9; }

        &:focus-within {
          border-color: #00d9a9;
          box-shadow: 0 0 0 2px rgba(0, 217, 169, 0.1);
        }

        .ant-input {
          font-size: 14px;
          border: none;
          box-shadow: none;
          &:focus { box-shadow: none; }
        }

        .ant-input-prefix { color: #999; margin-right: 8px; }
      }
    }

    .search-filters-row {
      display: flex;
      gap: 10px;
      align-items: center;
      flex-wrap: wrap;

      .primary-filter {
        flex: 1;
        min-width: 130px;

        .ant-select-selector {
          border-radius: 8px;
          height: 40px !important;
          &:hover { border-color: #00d9a9 !important; }
        }

        .ant-select-selection-placeholder,
        .ant-select-selection-item { line-height: 38px !important; }

        &.ant-select-focused .ant-select-selector {
          border-color: #d9d9d9 !important;
          box-shadow: none !important;
        }
      }

      .more-filters-btn {
        border-color: #d9d9d9;
        color: #595959;
        border-radius: 8px;
        font-weight: 500;
        height: 40px;
        padding: 0 16px;
        white-space: nowrap;
        &:hover { border-color: #00d9a9; color: #00d9a9; background: #e6fff9; }
      }

      .clear-all-btn {
        color: #ff4d4f;
        font-weight: 500;
        height: 40px;
        padding: 0 8px;
        &:hover { color: #ff7875; }
      }
    }
  }

  .content-section {
    padding: 16px 0 24px 0;
  }

  .jobs-list-column {
    width: 100%;
    max-width: 100%;
    margin-bottom: 24px;

    .jobs-scroll-container {
      max-height: 85vh;
      overflow-y: auto;
      width: 100%;
      padding-right: 8px;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 3px;
        
        &:hover {
          background: #999;
        }
      }
    }

    .job-list-card {
      margin-bottom: 12px;
      border-radius: 10px;
      border: 1px solid #e8e8e8;
      border-left: 3px solid transparent;
      transition: all 0.25s ease;
      cursor: pointer;
      background: white;

      &:hover {
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.09);
        border-left-color: #00d9a9;
        transform: translateY(-1px);
      }

      &.selected {
        border-color: #00d9a9;
        border-left-color: #009e7a;
        background: #f0fdf9;
        box-shadow: 0 2px 10px rgba(0, 217, 169, 0.18);

        .card-salary-amount {
          color: #007a5e;
        }

        .card-match-pill.has-match {
          background: #d0f5ec;
          border-color: #00c49b;
          color: #005f48;
        }
      }

      .ant-card-body {
        padding: 14px 16px;
      }

      .card-meta-row {
        display: flex;
        gap: 16px;
        margin-bottom: 8px;

        .card-meta-item {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 12px;
          color: #8c8c8c;

          .anticon {
            color: #00d9a9;
            font-size: 12px;
          }
        }
      }

      .card-title {
        font-size: 14px;
        font-weight: 700;
        color: #014c75;
        line-height: 1.4;
        margin-bottom: 10px;

        .card-exp {
          font-size: 12px;
          font-weight: 500;
          color: #8c8c8c;
        }
      }

      .card-salary-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .card-type-tag {
          border-radius: 4px;
          font-size: 12px;
          margin: 0;
        }

        .card-salary-amount {
          font-size: 15px;
          font-weight: 700;
          color: #00a87a;
          letter-spacing: -0.2px;

          .card-salary-period {
            font-size: 11px;
            font-weight: 500;
            color: #8c8c8c;
          }
        }
      }

      .card-skills-row {
        margin-bottom: 10px;

        .ant-tag {
          font-size: 11px;
          border-radius: 4px;
          margin: 0;
        }
      }

      .card-match-row {
        margin-top: 4px;
        display: flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;

        .card-match-pill {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          font-size: 12px;
          font-weight: 600;
          padding: 3px 10px;
          border-radius: 4px;
          background: #f5f5f5;
          border: 1px solid #e0e0e0;
          color: #8c8c8c;

          &.has-match {
            background: #e6fff9;
            border-color: #00d9a9;
            color: #007a5e;
          }

          .anticon {
            font-size: 11px;
          }
        }

        .card-match-pct-pill {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 12px;
          font-weight: 600;
          padding: 3px 10px;
          border-radius: 4px;

          &.pct-high {
            background: #f6ffed;
            border: 1px solid #b7eb8f;
            color: #389e0d;
          }

          &.pct-mid {
            background: #fffbe6;
            border: 1px solid #ffe58f;
            color: #d48806;
          }

          &.pct-low {
            background: #f5f5f5;
            border: 1px solid #d9d9d9;
            color: #8c8c8c;
          }
        }
      }
    }
  }

  .job-details-column {
    width: 100%;
    max-width: 100%;

    .details-card {
      min-height: 200px;
      width: 100%;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      border: 1px solid #e8e8e8;
      background: white;

      .ant-card-body {
        padding: 24px;
      }

      .job-header-row {
        margin-bottom: 0;

        .label {
          color: #014c75;
          font-size: 14px;
          margin-right: 8px;
        }

        .info-text {
          font-size: 14px;
          color: #595959;
          display: block;

          .anticon {
            color: #00d9a9;
            margin-right: 4px;
          }
        }

        .ant-tag {
          border-radius: 4px;
        }

        .submit-btn-col {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }

        .submit-profiles-btn {
          background: #00d9a9;
          border-color: #00d9a9;
          font-weight: 600;
          height: 44px;
          padding: 0 32px;
          font-size: 15px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 217, 169, 0.3);

          &:hover {
            background: #01c49b;
            border-color: #01c49b;
            box-shadow: 0 6px 16px rgba(0, 217, 169, 0.4);
            transform: translateY(-2px);
          }

          &:active {
            transform: translateY(0);
          }
        }
      }

      .ant-divider {
        margin: 14px 0;
      }

      .title-row {
        margin-bottom: 14px;

        h4 {
          color: #014c75;
          font-weight: 700;
          font-size: 17px;
          margin: 0;
          line-height: 1.4;
        }

        .exp-badge {
          font-size: 13px;
          font-weight: 500;
          color: #8c8c8c;
        }
      }

      .salary-hero-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 18px;

        .salary-hero-amount {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 20px;
          font-weight: 700;
          color: #00966d;
          letter-spacing: -0.3px;
          background: #edfbf6;
          border: 1px solid #c3f0e0;
          border-radius: 8px;
          padding: 5px 14px;

          .anticon {
            font-size: 17px;
            color: #00d9a9;
          }
        }

        .salary-hero-period {
          font-size: 11px;
          font-weight: 600;
          color: #aaa;
          text-transform: uppercase;
          letter-spacing: 0.6px;
        }
      }

      .meta-pills-row {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        margin-bottom: 4px;

        .meta-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: #f5f5f5;
          border: 1px solid #e8e8e8;
          border-radius: 20px;
          padding: 4px 14px 4px 10px;
          font-size: 13px;

          .meta-icon {
            color: #00d9a9;
            font-size: 13px;
          }

          .meta-label {
            color: #8c8c8c;
            font-weight: 400;
          }

          .meta-value {
            color: #262626;
            font-weight: 600;
          }
        }
      }

      .skills-section {
        margin-bottom: 12px;
        display: flex;
        align-items: flex-start;
        gap: 10px;
        flex-wrap: wrap;

        .skill-section-label {
          display: inline-block;
          font-size: 12px;
          font-weight: 600;
          border-radius: 4px;
          padding: 2px 8px;
          white-space: nowrap;
          margin-top: 2px;

          &.primary-label {
            background: #e6f4ff;
            color: #0958d9;
            border: 1px solid #91caff;
          }

          &.good-label {
            background: #e6fffb;
            color: #087554;
            border: 1px solid #87e8de;
          }
        }

        .ant-tag {
          margin: 0;
          border-radius: 4px;
          font-size: 12px;
        }
      }

      .info-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px 16px;
        margin-bottom: 14px;
        background: #fafafa;
        border: 1px solid #f0f0f0;
        border-radius: 8px;
        padding: 14px 16px;

        .info-cell {
          display: flex;
          align-items: flex-start;
          gap: 10px;

          .info-icon {
            color: #00d9a9;
            font-size: 15px;
            margin-top: 2px;
            flex-shrink: 0;
          }

          .info-cell-content {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .info-cell-label {
              font-size: 11px;
              color: #8c8c8c;
              font-weight: 500;
              text-transform: uppercase;
              letter-spacing: 0.4px;
            }

            .info-cell-value {
              font-size: 13px;
              color: #262626;
              font-weight: 500;
            }
          }
        }
      }

      .description-section {
        .description-title {
          color: #014c75;
          font-size: 16px;
          font-weight: 600;
          display: block;
          margin-bottom: 12px;
        }

        .description-text {
          color: #595959;
          line-height: 1.8;
          margin-bottom: 0;
          font-size: 14px;
          white-space: pre-line;
          text-align: justify;
        }
      }

      .empty-state {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 200px;
      }
    }
  }

  .ant-drawer {
    .ant-drawer-header {
      background: #f8f9fd;
      border-bottom: 1px solid #e8e8e8;

      .ant-drawer-title {
        color: #014c75;
        font-weight: 600;
      }
    }

    .ant-drawer-body {
      .ant-select {
        .ant-select-selector {
          border-radius: 6px;
          
          &:hover {
            border-color: #00d9a9;
          }
        }

        &.ant-select-focused .ant-select-selector {
          border-color: #00d9a9;
          box-shadow: 0 0 0 2px rgba(0, 217, 169, 0.1);
        }
      }

      .ant-typography-strong {
        color: #014c75;
        font-size: 14px;
      }
    }
  }

  @media (max-width: 992px) {
    .job-details-column {
      .details-card {
        .job-header-row {
          .submit-btn-col {
            justify-content: flex-start;
            margin-top: 16px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .search-section {
      .search-filters-row {
        .search-input {
          width: 100%;
          min-width: auto;
        }

        .primary-filter {
          width: calc(50% - 6px);
        }

        .more-filters-btn {
          width: 100%;
        }
      }
    }

    .jobs-list-column {
      .jobs-scroll-container {
        max-height: 50vh;
      }
    }

    .job-details-column {
      .details-card {
        .job-header-row {
          .ant-col {
            margin-bottom: 8px;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .search-section {
      padding: 16px 12px 0 12px;

      .search-filters-row {
        .primary-filter {
          width: 100%;
        }
      }
    }

    .content-section {
      padding: 16px 12px;
    }

    .job-details-column {
      .details-card {
        .ant-card-body {
          padding: 16px;
        }

        .job-header-row {
          .submit-profiles-btn {
            width: 100%;
          }
        }
      }
    }
  }
`;
